var _path;

var _excluded = ["title", "titleId"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.720 5.303 C 9.569 5.368,3.436 11.461,3.342 11.640 C 3.250 11.815,3.230 12.000,3.282 12.194 C 3.328 12.366,3.559 12.609,6.436 15.491 C 8.525 17.585,9.593 18.628,9.703 18.681 C 9.792 18.724,9.916 18.760,9.978 18.760 C 10.343 18.760,10.691 18.478,10.742 18.140 C 10.803 17.733,10.900 17.847,8.227 15.170 L 5.781 12.720 12.472 12.720 C 18.001 12.720,19.185 12.711,19.292 12.666 C 19.520 12.571,19.760 12.220,19.760 11.980 C 19.760 11.740,19.520 11.389,19.292 11.294 C 19.185 11.249,18.004 11.240,12.492 11.240 L 5.821 11.240 8.247 8.810 C 10.332 6.722,10.680 6.357,10.722 6.214 C 10.898 5.610,10.291 5.058,9.720 5.303 ",
    stroke: "none",
    fillRule: "evenodd",
    fill: "black"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.1516f3b7.svg";
export { ForwardRef as ReactComponent };